import type { BasicPalette } from '@theme/theme.types'

export function exportObjectToGlobalCssProperties(colorPalette: Partial<BasicPalette>) {
  if (globalThis.document) {
    return Object.entries(colorPalette).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--p-${key}`, value)
    })
  }
}
